import { Controller } from "@hotwired/stimulus"
import { useDispatch } from "stimulus-use"

export default class extends Controller {
  connect() {
    useDispatch(this)

    this.dispatch("connect")
  }

  scroll() {
    this.element.scrollIntoView()
  }
}
